import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MbscSelectOptions } from '@mobiscroll/angular';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';
import { PDxListItem } from 'src/app/core/PDxListItem.model';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { EntityHeaderInformation } from '../models/entity-header-information.model';

@Component({
  selector: 'app-entity-move',
  templateUrl: './entity-move.component.html',
  styles: [
  ]
})
export class EntityMoveComponent implements OnInit {
  @ViewChild(NgForm) moveForm!: NgForm;

  accountId: string = null;
  accounts: PDxListItem<string>[] = [];
  parentId: string = null;
  parents: PDxListItem<string>[] = [];
  entity: EntityHeaderInformation;
  filterCount: number = 0;
  moveDetail: MoveDetailInformation = new MoveDetailInformation();
  submitAttempt: boolean = false;

  accountOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.accounts = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: null, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.accounts = data;
            this.validateCurrentAccount()
          }
        }, () => { });
      } else {
        this.validateCurrentAccount()
      }
      return false;
    },
    onChange: (ev: any) => {
      this.moveDetail.hierarchy = this.accounts.filter((x) => x.value == ev.value);
      this.parentId = null;
      this.parents = [];
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.moveDetail.hierarchy = [];
        this.accountId = null;
        this.parentId = null;
      }
    }]
  };

  parentOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.parents = [];
      if (!this.accountId) {
        return false;
      }
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/DropDownList', { accountId: this.accountId, query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.parents = data;
            this.validateCurrentParent()
          }
        }, () => { });
      } else {
        this.validateCurrentParent()
      }
      return false;
    },
    onChange: (ev: any) => {
      this.ajax.MakeCall<PDxListItem<string>[]>('/Entity/Hierarchy', { entityId: this.parentId }, false).then((data) => {
        this.moveDetail.hierarchy = data;
      }, () => { });
    },
    buttons: [{
      text: 'clear', handler: (event) => {
        this.parentId = null;
      }
    }]
  };

  constructor(private ajax: ajaxCall,
    private dirtyService: DirtyTrackingService,
    private confirmService: ConfirmService,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  validateCurrentAccount(): void {
    if (this.moveDetail.hierarchy.length > 0) {
      if (this.accounts.filter((x) => x.value == this.moveDetail.hierarchy[0].value).length == 0) {
        this.accounts.splice(0, 0, this.moveDetail.hierarchy[0]);
      }
    }
  }

  validateCurrentParent(): void {
    if (this.moveDetail.hierarchy.length > 1) {
      if (this.parents.filter((x) => x.value == this.moveDetail.hierarchy[this.moveDetail.hierarchy.length - 1].value).length == 0) {
        this.parents.splice(0, 0, this.moveDetail.hierarchy[this.moveDetail.hierarchy.length - 1]);
      }
    }
  }

  moveEntity(): void {
    this.submitAttempt = true;
    if (this.moveForm.invalid) {
      return;
    }
    this.confirmService.confirm('Move ' + this.entity.displayName, 'Are you sure that you want to move this entity?', 'Re-Assign').then(() => {
      this.ajax.MakeCall('/Entity/Move', { entityId: this.entity.entityId, parentId: this.parentId || this.accountId }).then((data) => {
        this.modal.close();
      }, () => { });
    });
  }
}

class MoveDetailInformation {
  constructor() {
    this.hierarchy = [];
  }

  hierarchy: PDxListItem<string>[];
}